import { styleConstants } from '@paywithextend/components'
import React from 'react'
import { css, FlattenSimpleInterpolation } from 'styled-components'

export enum LoadingShimmerType {
  OnWhite,
  OnGrayLight,
}

export interface LoadingShimmerProps {
  className?: string
  height?: string
  width?: string
  type?: LoadingShimmerType
}

const getBackground = (
  type: LoadingShimmerType,
): FlattenSimpleInterpolation => {
  switch (type) {
    case LoadingShimmerType.OnGrayLight:
      return css`linear-gradient(90deg, ${styleConstants.colors.gray_light}, ${styleConstants.colors.gray_dark})`
    case LoadingShimmerType.OnWhite:
      return css`linear-gradient(90deg, ${styleConstants.colors.gray_medium}, ${styleConstants.colors.white})`
  }
}

const LoadingShimmer: React.FC<LoadingShimmerProps> = (props) => {
  return (
    <>
      {
        <div
          className={props.className}
          css={css`
            display: block;
            width: ${props.width || '126px'};
            height: ${props.height || '26px'};
            border-radius: 10px;
            background: ${getBackground(
              props.type ?? LoadingShimmerType.OnWhite,
            )};
            background-size: 300% 100%;
            animation: gradient 1.5s ease-in infinite;

            @keyframes gradient {
              0% {
                background-position: 100% 0%;
              }
              50% {
                background-position: 0% 0%;
              }
              100% {
                background-position: 100% 0%;
              }
            }

            @media (prefers-reduced-motion: reduce) {
              animation: none;
            }
          `}
        />
      }
    </>
  )
}

export default LoadingShimmer
